import AwaitValue from "./AwaitValue";
export default function _awaitAsyncGenerator(value) {
  return new AwaitValue(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@luma.gl/addons/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator.js
// module id = 497
// module chunks = 0